// src/components/Promos/NewsButton.jsx
import React from "react";

export default function NewsButton({
  onClick,
  label = "Nouveauté",
  className = "",
}) {
  return (
    <button
      type="button"
      className={`promos-btn promos-btn--news ${className}`.trim()}
      onClick={onClick}
    >
       {label}
    </button>
  );
}
